import React from 'react';

const PELLET_COLORS = ['var(--gold)', 'var(--green)', 'var(--blue)', 'var(--gold2)'];

function Pellets({ count = 14, seed = 0 }) {
  return (
    <div className="process-bg__pellets">
      {Array.from({ length: count }, (_, i) => {
        const n = i + seed;
        return (
          <span
            key={n}
            className="process-bg__pellet"
            style={{
              left: `${(n * 17 + seed * 11) % 96 + 2}%`,
              animationDelay: `${-(n * 0.7 + seed) % 10}s`,
              animationDuration: `${9 + (n % 5)}s`,
              background: PELLET_COLORS[n % PELLET_COLORS.length],
              width: `${6 + (n % 4)}px`,
              height: `${6 + (n % 4)}px`,
            }}
          />
        );
      })}
    </div>
  );
}

/**
 * Animated masterbatch / color-batch manufacturing background.
 * @param {'stream'|'compound'|'extrusion'|'analytics'|'lab'|'eco'|'conveyor'|'shimmer'|'quality'|'formulation'} variant
 */
export default function SectionProcessBg({ variant = 'compound', seed = 0 }) {
  return (
    <div className={`process-bg process-bg--${variant}`} aria-hidden="true">
      <div className="process-bg__grid" />
      <div className="process-bg__glow" />
      {(variant === 'extrusion' ||
        variant === 'compound' ||
        variant === 'eco' ||
        variant === 'conveyor' ||
        variant === 'formulation') && <Pellets count={variant === 'extrusion' ? 18 : 12} seed={seed} />}
      {variant === 'stream' && <div className="process-bg__pigment-stream" />}
      {variant === 'analytics' && <div className="process-bg__chart-lines" />}
      {variant === 'lab' && (
        <>
          <div className="process-bg__mixer" />
          <Pellets count={10} seed={seed + 3} />
        </>
      )}
      {variant === 'shimmer' && <div className="process-bg__shimmer" />}
      {variant === 'quality' && <div className="process-bg__scan-beam" />}
    </div>
  );
}
